/* =========================================================================
   INNER PURE – BALLASTSTOFF-QUIZ (überarbeitet)
   -------------------------------------------------------------------------
   Benötigtes HTML auf der Seite (Liquid):

     <div id="quiz"></div>
     <div id="result-box" style="display:none;"></div>

     <!-- WICHTIG für zuverlässiges Klaviyo-Rendering:
          Den Embed-Div FEST und VERSTECKT ins statische HTML legen,
          damit Klaviyo ihn beim Seitenload mountet. Das Quiz blendet
          ihn am Ende nur ein (statt ihn neu zu erzeugen). -->
     <div id="quiz-klaviyo-pre" style="display:none;">
       <div class="klaviyo-form-WG4zLb"></div>
     </div>
   ========================================================================= */
(() => {
  /* =============================== KONFIGURATION =============================== */
  const questions = [
    { q: "Wie viele Portionen Obst und Gemüse isst du pro Tag?", a:[1,2,2,3], o:["0–1","2","3–4","5 oder mehr"] },
    { q: "Wie häufig isst du Vollkornprodukte?", a:[1,2,2,3], o:["Selten","1–2× pro Woche","Mehrmals pro Woche","Täglich"] },
    { q: "Wie oft isst du Hülsenfrüchte?", a:[1,2,2,3], o:["Nie","1× pro Woche","2–3× pro Woche","Fast täglich"] },
    { q: "Isst du regelmäßig Nüsse oder Samen?", a:[1,2,2,3], o:["Sehr selten","1–2× pro Woche","Mehrmals pro Woche","Täglich"] },
    { q: "Wie oft greifst du zu Snacks wie Chips oder Süßigkeiten?", a:[3,2,1,1], o:["Selten","Mehrmals pro Woche","Täglich","Mehrmals täglich"] },
    { q: "Fühlst du dich nach Mahlzeiten oft aufgebläht?", a:[3,2,1,1], o:["Selten","Manchmal","Oft","Sehr häufig"] },
    { q: "Trinkst du mindestens 1,5–2 Liter Wasser?", a:[1,1,2,3], o:["Fast nie","Manchmal","Meistens","Ja, täglich ausreichend"] },
    { q: "Wie würdest du deine Verdauung beschreiben?", a:[1,1,2,3], o:["Unregelmäßig","Eher unregelmäßig","Meistens normal","Sehr regelmäßig"] },
    { q: "Wie oft nimmst du bewusst ballaststoffreiche Lebensmittel zu dir?", a:[1,2,2,3], o:["Gar nicht","Wenig","Regelmäßig","Sehr regelmäßig"] },
    { q: "Wie häufig achtest du beim Einkaufen auf ballaststoffreiche Produkte?", a:[1,2,2,3], o:["Nie","Selten","Oft","Immer"] }
  ];

  const KLAVIYO_FORM_ID = "WG4zLb";

  // FIX: relative URLs -> Besucher bleibt auf innerpure.de (kein myshopify-Domainwechsel).
  // Ergebnis-basiertes Routing statt überall /collections/all.
  const RESULT_CONFIG = {
    low:  { url: "/products/cfb-o1-clear-daily", cta: "Jetzt mit Clear Fiber starten",
            title: "Du brauchst wahrscheinlich mehr Ballaststoffe.",
            text:  "Viele Menschen erreichen die empfohlenen Mengen nicht. Mit kleinen Anpassungen – und einer einfachen täglichen Basis – kannst du viel verbessern.",
            label: "Niedrig" },
    mid:  { url: "/products/cfb-o1-clear-daily", cta: "Clear Fiber ansehen",
            title: "Du machst vieles richtig!",
            text:  "Du bist auf einem guten Weg – mit ein paar kleinen Anpassungen kannst du deine Verdauung weiter verbessern.",
            label: "Mittel" },
    high: { url: "/collections/all", cta: "Produkte entdecken",
            title: "Sehr gut! Deine Ballaststoffaufnahme ist top!",
            text:  "Du achtest bereits sehr gut auf deine Ernährung. Vielleicht willst du noch gezielter optimieren.",
            label: "Hoch" }
  };

  // Score-Grenzen aus den Daten ableiten (statt hartkodierter 30).
  const MAX_SCORE = questions.reduce((s, q) => s + Math.max(...q.a), 0);
  const MIN_SCORE = questions.reduce((s, q) => s + Math.min(...q.a), 0);

  let current = 0;
  const answers = new Array(questions.length).fill(null); // gespeicherte Punkte je Frage (ermöglicht "Zurück")

  const $ = (id) => document.getElementById(id);
  const score = () => answers.reduce((s, p) => s + (p || 0), 0);

  function levelFor(s) {
    if (s <= 15) return "low";
    if (s <= 22) return "mid";
    return "high";
  }

  /* =============================== QUIZ-LOGIK =============================== */
  function loadQuestion() {
    const quizEl = $("quiz");
    const resultEl = $("result-box");
    if (!quizEl || !resultEl) return;

    if (current >= questions.length) return showResult();

    resultEl.style.display = "none";

    const q = questions[current];
    const progress = Math.round((current / questions.length) * 100);

    let html = `
      <div class="quiz-progress" style="margin-bottom:14px;">
        <div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:6px;">
          <span>Frage ${current + 1} von ${questions.length}</span>
          <span>${progress}%</span>
        </div>
        <div style="background:#ddd;height:8px;border-radius:10px;">
          <div style="width:${progress}%;height:8px;background:#A9B5A1;border-radius:10px;transition:width .3s;"></div>
        </div>
      </div>
      <div class="quiz-question">${q.q}</div>
      <div class="quiz-options">`;

    q.o.forEach((option, i) => {
      const selected = answers[current] === q.a[i] ? ' aria-pressed="true"' : '';
      html += `<button type="button" data-index="${i}"${selected}>${option}</button>`;
    });
    html += `</div>`;

    if (current > 0) {
      html += `<button type="button" class="quiz-back"
                 style="margin-top:12px;background:none;border:none;text-decoration:underline;cursor:pointer;font-size:14px;">← Zurück</button>`;
    }

    quizEl.innerHTML = html;

    quizEl.querySelectorAll("button[data-index]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const i = Number(btn.dataset.index);
        answers[current] = questions[current].a[i];
        current++;
        loadQuestion();
      });
    });

    const back = quizEl.querySelector(".quiz-back");
    if (back) back.addEventListener("click", () => { current = Math.max(0, current - 1); loadQuestion(); });
  }

  function showResult() {
    const quizEl = $("quiz");
    const resultEl = $("result-box");
    if (!resultEl) return;

    const s = score();
    const r = RESULT_CONFIG[levelFor(s)];

    // FIX: normalisierte Prozentanzeige (Min-Score ist 10, nicht 0).
    const span = MAX_SCORE - MIN_SCORE;
    const pct = span > 0 ? Math.max(0, Math.min(100, Math.round(((s - MIN_SCORE) / span) * 100))) : 0;

    if (quizEl) quizEl.innerHTML = "";

    resultEl.innerHTML = `
      <div class="result-title">${r.title}</div>
      <p><strong>Dein Punktestand:</strong> ${s} von ${MAX_SCORE} Punkten</p>
      <p><strong>Kategorie:</strong> ${r.label}</p>

      <div style="margin:15px 0;">
        <div style="background:#ddd;height:18px;border-radius:10px;">
          <div style="width:${pct}%;height:18px;background:#A9B5A1;border-radius:10px;transition:width 1s;"></div>
        </div>
        <p style="margin-top:5px;font-size:14px;">${pct}%</p>
      </div>

      <p>${r.text}</p>

      <a class="shop-button" href="${r.url}">${r.cta}</a>

      <div id="quiz-leadmagnet" style="margin-top:24px;padding-top:18px;border-top:1px solid rgba(40,40,40,0.12);">
        <p style="margin:0 0 10px 0;">
          <strong>Hol dir deinen persönlichen Ballaststoff-Plan per E-Mail.</strong><br>
          Trag dich ein – wir schicken dir passend zu deinem Ergebnis konkrete Tipps:
        </p>
        <!-- Klaviyo-Embed wird hier eingehängt (siehe revealKlaviyoForm) -->
      </div>
    `;
    resultEl.style.display = "block";

    sendResultToKlaviyo(s, r.label, levelFor(s));
    revealKlaviyoForm();
  }

  /* =============================== KLAVIYO =============================== */
  // Ergebnis für Segmentierung bereitstellen.
  // Hinweis: zuverlässige Profil-Zuordnung passiert über die E-Mail aus dem Formular.
  // Für die Score-Übergabe gibt es zwei gängige Wege:
  //  (a) Hidden-Field im Klaviyo-Formular, das einen URL-Parameter liest (wird hier gesetzt), oder
  //  (b) ein Track-Event (greift, sobald das Profil identifiziert ist).
  function sendResultToKlaviyo(scoreValue, label, key) {
    try {
      // (a) URL-Parameter setzen -> im Klaviyo-Formular als Hidden-Field mappen
      const url = new URL(window.location.href);
      url.searchParams.set("fiber_level", label);
      url.searchParams.set("fiber_score", String(scoreValue));
      window.history.replaceState(null, "", url.toString());

      // global verfügbar machen (falls du eigene Hidden-Inputs befüllen willst)
      window.__fiberQuiz = { score: scoreValue, level: label, level_key: key };

      // (b) best-effort Track-Event – an dein Klaviyo-Setup anpassen
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(["track", "Completed Fiber Quiz", { score: scoreValue, level: label }]);
    } catch (_) {}
  }

  // Klaviyo-Embed zuverlässig anzeigen.
  function revealKlaviyoForm() {
    const target = $("quiz-leadmagnet");
    if (!target) return;

    // 1) EMPFOHLEN: vorgemountetes Formular aus dem statischen HTML wiederverwenden.
    //    Klaviyo hat es beim Seitenload bereits gerendert -> zuverlässig sichtbar.
    const pre = $("quiz-klaviyo-pre");
    if (pre) {
      pre.style.display = "block";
      target.appendChild(pre);
      return;
    }

    // 2) FALLBACK: Div einsetzen. ACHTUNG: dynamisch injizierte Embeds werden von
    //    Klaviyo nicht zuverlässig gemountet – Variante 1 ist klar zu bevorzugen.
    const div = document.createElement("div");
    div.className = "klaviyo-form-" + KLAVIYO_FORM_ID;
    target.appendChild(div);
  }

  /* =============================== INIT =============================== */
  // FIX: nicht nur auf DOMContentLoaded warten – falls das Skript erst nach dem
  // Laden eingebunden wird, ist das Event schon gefeuert und das Quiz startet nie.
  function init() { loadQuestion(); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();